var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeacherAvatar = function SvgTeacherAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.56 11.572h-.339a5.31 5.31 0 0 1-4.44 0h-.34a4.265 4.265 0 0 0-4.25 3.92c-.016.201.148.322.319.433.611.4 3.714.886 6.491.886 2.777 0 5.591-.485 6.491-.886.185-.082.335-.232.319-.434a4.266 4.266 0 0 0-4.251-3.919M6.102 7.09a3.9 3.9 0 1 1 7.798-.002 3.9 3.9 0 0 1-7.798.002",
    fillRule: "evenodd"
  })));
};

export default SvgTeacherAvatar;